import React from 'react';

interface ProjectImageProps {
  src: string;
  alt?: string;
  title: string;
  description: string;
}

const ProjectImage: React.FC<ProjectImageProps> = ({ src, alt = "Gameplay", title, description }) => {
  return (
    <div className="project-single-image">
      <img src={src} alt={alt} className="a-image loading-bg" />
      <div className="carousel-title">{title}</div>
      <div className="carousel-desc">{description}</div>
    </div>
  );
};

export default ProjectImage;